<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3485 3485"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_124613680">
   <g>
    <path class="fil0" d="M1127 0c-862,0 -1127,748 -1127,1118 0,369 170,653 303,795 133,142 227,171 265,455 38,284 246,284 246,284l285 0 56 0 285 0c0,0 208,0 246,-284 38,-284 132,-313 265,-455 133,-142 303,-426 303,-795 0,-370 -265,-1118 -1127,-1118z"/>
   </g>
   <g>
    <path class="fil0" d="M1411 2889l-284 0 -9 0 -285 0c0,0 -199,0 -199,142 0,142 48,255 114,255 66,0 133,199 133,199l237 0 9 0 237 0c0,0 66,-199 132,-199 67,0 114,-113 114,-255 0,-142 -199,-142 -199,-142z"/>
   </g>
  </g>
 </g>
 <g id="Vrstva_x0020_1_0">
  <path class="fil1" d="M480 1500l0 -456 202 0c40,0 71,4 92,12 22,9 38,23 51,44 13,20 19,43 19,68 0,33 -10,60 -31,82 -21,22 -54,36 -97,42 16,8 28,16 36,23 18,16 34,37 50,61l79 124 -76 0 -60 -95c-17,-27 -32,-48 -43,-63 -12,-14 -22,-24 -31,-30 -9,-6 -18,-10 -27,-12 -7,-2 -18,-2 -34,-2l-70 0 0 202 -60 0zm60 -255l130 0c27,0 49,-2 64,-8 16,-6 28,-15 35,-28 9,-12 13,-26 13,-40 0,-22 -8,-40 -24,-54 -15,-14 -40,-21 -74,-21l-144 0 0 151z"/>
  <path id="1" class="fil1" d="M1152 1321l0 -53 193 0 0 169c-30,23 -61,41 -92,53 -32,12 -64,18 -97,18 -45,0 -86,-10 -122,-29 -37,-19 -64,-47 -83,-83 -19,-36 -28,-77 -28,-122 0,-44 9,-85 28,-124 18,-38 45,-67 80,-85 35,-19 75,-28 120,-28 33,0 63,5 90,16 26,10 47,25 62,44 15,19 27,44 35,75l-55 15c-7,-23 -15,-42 -25,-55 -10,-13 -25,-24 -44,-32 -18,-8 -39,-12 -62,-12 -28,0 -52,4 -72,13 -20,8 -36,19 -48,33 -13,14 -22,29 -29,45 -12,28 -18,59 -18,92 0,41 7,75 21,102 14,28 35,48 61,61 27,14 55,20 86,20 26,0 51,-5 76,-15 25,-10 44,-21 56,-32l0 -86 -133 0z"/>
  <path id="2" class="fil1" d="M1431 1500l0 -456 171 0c35,0 63,5 84,14 21,9 38,23 49,43 12,19 18,39 18,60 0,19 -5,38 -15,55 -11,17 -27,31 -48,41 27,9 49,22 63,42 15,19 23,42 23,69 0,21 -5,41 -14,59 -9,19 -20,33 -33,43 -14,10 -30,17 -50,22 -20,6 -45,8 -74,8l-174 0zm61 -264l98 0c27,0 46,-2 58,-5 15,-5 27,-13 34,-23 8,-11 12,-24 12,-40 0,-15 -3,-29 -11,-40 -7,-12 -17,-20 -31,-24 -13,-4 -37,-6 -69,-6l-91 0 0 138zm0 211l113 0c20,0 33,-1 41,-3 14,-2 26,-6 35,-12 10,-6 17,-14 23,-25 6,-12 9,-25 9,-39 0,-17 -4,-32 -13,-45 -9,-12 -21,-21 -36,-26 -16,-5 -38,-8 -67,-8l-105 0 0 158z"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'RGBLight',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE;fill-rule:nonzero}
.fil0 {fill:#CCCCCC;fill-rule:nonzero}
</style>
